.dropdownMenu {
  position: relative;
  display: inline-block;
}

.dropdownMenu__trigger {
  display: flex;
  align-items: center;
  gap: 0.75rem;
  border: 0.5px solid var(--color-border-muted);
  border-radius: 0.25rem;
  background: transparent;
  cursor: pointer;
  color: var(--color-text-on-dark);
  font-family: var(--font-lucid-sans);
  transition: border-color 0.15s ease;
}

.dropdownMenu__trigger:hover {
  border-color: var(--color-border-muted);
}

.dropdownMenu__trigger--user {
  padding: 0.375rem 1rem;
  min-width: 10rem;
  overflow: hidden;
}

.dropdownMenu__trigger--dots {
  padding: 0.25rem;
  min-width: unset;
  height: unset;
  border: none;
  justify-content: center;
  color: var(--color-text-on-dark);
}

.dropdownMenu__trigger--dots:hover {
  border: none;
  color: var(--color-text-brand-accent);
}

.dropdownMenu__trigger--label {
  padding: 0.5625rem 1rem;
  height: 2rem;
  border: 0.0625rem solid var(--color-border-muted);
  border-radius: 0.25rem;
  background: var(--color-bg-surface);
  color: var(--color-text-secondary);
  gap: 0.75rem;
}

.dropdownMenu__labelText {
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
}

.dropdownMenu__userInfo {
  display: flex;
  flex-direction: column;
  gap: 0.25rem;
  flex: 1;
  min-width: 0;
  text-align: left;
}

.dropdownMenu__userName {
  font-size: 0.875rem;
  line-height: 1.125rem;
  font-weight: 400;
  font-style: normal;
  color: var(--color-text-inverse);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropdownMenu__userSubtitle {
  font-size: 0.75rem;
  line-height: 1rem;
  font-weight: 400;
  font-style: normal;
  color: var(--color-text-disabled);
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
}

.dropdownMenu__chevron {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
  width: 1rem;
  height: 1rem;
  color: var(--color-text-on-dark);
  transition: transform 0.2s ease;
}

.dropdownMenu__chevron--open {
  transform: rotate(180deg);
}

.dropdownMenu__dotsIcon {
  display: flex;
  align-items: center;
  justify-content: center;
  color: var(--color-text-on-dark);
}

.dropdownMenu__panel {
  position: absolute;
  top: calc(100% + 0.125rem);
  z-index: 100;
  list-style: none;
  margin: 0;
  padding: 0;
  background: var(--color-bg-white);
  border: 0.5px solid var(--color-text-faded);
  border-radius: 0.25rem;
  overflow: hidden;
  min-width: 100%;
  white-space: nowrap;
}

.dropdownMenu__panel--left {
  left: 0;
}

.dropdownMenu__panel--right {
  right: 0;
}

.dropdownMenu__item {
  display: block;
}

.dropdownMenu__itemBtn {
  display: flex;
  align-items: center;
  gap: 0.25rem;
  width: 100%;
  background: var(--color-bg-white);
  border: none;
  cursor: pointer;
  padding: 0.25rem;
  text-align: left;
  box-sizing: border-box;
}

.dropdownMenu__itemContent {
  display: flex;
  align-items: center;
  flex: 1 0 0;
  min-width: 0;
  padding: 0.25rem 0.5rem;
  border-radius: 0.25rem;
  font-family: var(--font-lucid-sans);
  font-size: 0.75rem;
  line-height: 1.125rem;
  font-weight: 400;
  font-style: normal;
  color: var(--color-text-disabled);
  transition:
    background-color 0.15s ease,
    color 0.15s ease;
}

.dropdownMenu__itemBtn:hover .dropdownMenu__itemContent,
.dropdownMenu__itemBtn:focus-visible .dropdownMenu__itemContent {
  background-color: var(--color-bg-brand-accent-subtle);
  color: var(--color-text-primary);
  outline: none;
}

.dropdownMenu__itemBtn:focus-visible {
  outline: none;
}
